import {ColumnConfig} from '@/types/dashboard'

export const DEFAULT_COLUMN_WIDTH = 300
export const defaultColumnConfig: ColumnConfig = {
    hidden: false,
    width: DEFAULT_COLUMN_WIDTH,
    order: 0,
    showIcon: false,
    showShortTextLabel: false,
    showFullTextLabel: false

}
